var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65244 7.20891L8.08596 0.775391L15.3422 8.03163L12.2389 11.135C10.3998 12.974 7.4175 12.974 5.57849 11.135L1.64941 7.20588L1.65244 7.20891Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9161 8.61914L22.3497 15.0527L10.1964 27.2059L7.21108 24.2205C5.30855 22.318 5.30855 19.2298 7.21108 17.3272L15.9161 8.62217V8.61914Z",
    fill: "CurrentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymob);
export default __webpack_public_path__ + "static/media/paymob.6b13cd2e4699eed873dbc572749efbe1.svg";
export { ForwardRef as ReactComponent };